<modal>
  <span header class="uppercase">{{product.ID == 0 ? ('Tạo mã hàng mới' | lang) : ('Sửa mã hàng' | lang) + ' ' + product.SKU}}</span>

  <p>{{'Mã nhà cung cấp' | lang}}</p>
  <input type="text" [disabled]="product.ID > 0" [(ngModel)]="producer" />
  <p>{{'Mã sản phẩm' | lang}}</p>
  <input type="text" [disabled]="product.ID > 0" [(ngModel)]="code" />
  <p>{{'Giá nhập' | lang}} (¥/{{product.Unit == 1 ? 'm' : 'kg'}}) <small style="float: right" *ngIf="!priceRetrived && product.UnitPrice == 0" class="text-primary pointer uppercase" (click)="getPrice()">{{'Lấy giá nhập cuối' | lang}}</small></p>
  <number-input [value]="product.UnitPrice" (change)="product.UnitPrice = $event.target.value" [allowNegativeValue]="false" [decimalPlaces]="2"></number-input>
  <p>{{'Tỷ lệ lãi' | lang}} (%)</p>
  <number-input [value]="product.ProfitMargin * 100" (change)="product.ProfitMargin = $event.target.value / 100" [allowNegativeValue]="false" [decimalPlaces]="1"></number-input>
  <p>{{'Phí vận chuyển' | lang}} (¥)</p>
  <number-input [value]="product.LogisticsMargin" (change)="product.LogisticsMargin = $event.target.value" [allowNegativeValue]="false" [decimalPlaces]="1"></number-input>
  <p>{{'Đơn vị' | lang}}</p>
  <select [(ngModel)]="product.Unit">
    <option [ngValue]="1">m</option>
    <option [ngValue]="2">kg</option>
  </select>
  <p>{{(product.Unit == 1 ? 'Độ dài trung bình 1 cây' : 'Trọng lượng trung bình 1 cây') | lang}}</p>
  <number-input [value]="product.AverageQuantity" (change)="product.AverageQuantity = $event.target.value" [allowNegativeValue]="false" [decimalPlaces]="1"></number-input>
  <p>{{'Mã màu' | lang}}</p>
  <input type="text" placeholder="{{'Thêm mã màu' | lang}}" class="uppercase" (change)="add($event.target.value); $event.target.value=''" />
  <div class="text-center">
    <span class="color" *ngFor="let i of product.Colors">{{i.Color}}<i class="fa fa-times text-danger pointer" (click)="remove(i)"></i></span>
  </div>

  <button *ngIf="valid" class="bg-primary text-white" (click)="save()"><i class="fa fa-save"></i><span>{{'Lưu thay đổi' | lang}}</span></button>
</modal>
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
